import React from "react";

var Embed = function Embed(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};

export default Embed;